import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { auth } from './auth.module';
import common from './common.module';
import { company } from './company.module';
import { edit } from './edit.module';
import { locale } from './locale.module';
import { notification } from './notification.module';
import { role } from './role.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    common,
    company,
    edit,
    locale,
    notification,
    role
  },

  plugins: [
    createPersistedState({
      key: 'vuex-pulverit-portal',
      paths: [
        'auth',
        'locale'
      ]
    })
  ]
});
